(function($) {
  
  document.addEventListener('DOMContentLoaded', function() {
    // Selects all buttons with class 'js-pwd-button'
    const pwdButtons = document.querySelectorAll('.js-pwd-button');

    pwdButtons.forEach(button => {
      button.addEventListener('click', function() {
        // Finds the input associated with the current button
        const pwdField = button.previousElementSibling;
        if (pwdField.type === 'password') {
          pwdField.type = 'text';
          button.textContent = button.getAttribute('data-hide-text');
          button.setAttribute('aria-label', button.getAttribute('data-hide-text') + ' password');
        } else {
          pwdField.type = 'password';
          button.textContent = button.getAttribute('data-show-text');
          button.setAttribute('aria-label', button.getAttribute('data-show-text') + ' password');
        }
      });
    });
  });

})(jQuery);
